// utils/quillBlots/inlineCommentStart.js

import Quill from "quill";

const Embed = Quill.import("blots/embed");

class InlineCommentStartBlot extends Embed {
  static blotName = "inlineCommentStart";
  static tagName = "span";
  static className = "ql-inline-comment-marker ql-inline-comment-marker--start";

  static create(value) {
    const node = super.create();

    const id = typeof value === "string" ? value : value?.id;
    if (id) node.setAttribute("data-comment-id", id);

    node.setAttribute("data-marker", "start");

    // Make it “invisible” but preserved in the document.
    node.setAttribute("contenteditable", "false");
    node.setAttribute("aria-hidden", "true");
    node.style.display = "inline-block";
    node.style.width = "0";
    node.style.height = "0";
    node.style.overflow = "hidden";
    node.style.lineHeight = "0";

    return node;
  }

  static value(node) {
    return {
      id: node.getAttribute("data-comment-id") || "",
      marker: "start",
    };
  }
}

Quill.register(InlineCommentStartBlot);

export default InlineCommentStartBlot;
